module.exports = __webpack_public_path__ + "img/arnx.236a878f.svg";